import React from 'react';
import { modules } from '../../data/offer';
import { Section } from './Section';
const formatPrice = (value: number) => `€ ${value.toLocaleString('nl-NL')}`.replace(/\s/g, '\u00a0');
export function Situation() {
  return <Section index="01" label="Opbouw" title="Vier onderdelen, los af te nemen" intro="Elk onderdeel heeft een eigen prijs en doorlooptijd. Samen vormen ze het complete systeem; je kunt ook later uitbreiden." data-id="element-111" data-mp="2ny9hm5si8x5u">
      <ul className="divide-y divide-line border-y border-line" data-id="element-112" data-mp="2e7esmtnvjjgp">
        {modules.map((item, index) => <li key={item.id} className="flex flex-wrap items-baseline justify-between gap-4 py-4" data-id="element-113" data-mp="258jp5pc7snh3" data-mpi={index}>
            <div className="flex items-baseline gap-4" data-id="element-114" data-mp="2a8pjjd9vco2v">
              <span className="text-xs font-semibold tabular-nums text-accent" data-id="element-115" data-mp="2a5a58co0rj2i">
                {String(index + 1).padStart(2, '0')}
              </span>
              <span className="text-lg font-semibold tracking-tight text-white" data-id="element-116" data-mp="2085edzj8azfd">
                {item.title}
              </span>
              <span className="text-xs uppercase tracking-[0.14em] text-white/35" data-id="element-117" data-mp="2vylcrnqbw1yw">
                {item.duration}
              </span>
            </div>
            <span className="whitespace-nowrap text-lg font-semibold tracking-tight text-white" data-id="element-118" data-mp="34xgi6xljt815">
              {formatPrice(item.price)}
            </span>
          </li>)}
      </ul>
    </Section>;
}